import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'app/theme/layout'
import { Mail, Phone } from 'react-feather'

import Slider from 'app/theme/slider'
import BackgroundCover from 'app/theme/BackgroundCover'
import NavbarFixed from 'app/theme/NavbarFixed'
import useLeadModal from './useLeadModal'

import RecentActivations from './RecentActivations'

import bannerImg from './img/banners/halo_top_nyc_22.png'

import styles from './AgencyPage.module.css'

import grid_select_la from './img/mobile-marketing-page/select_la_22.png'
import grid_plannedparenthood from './img/mobile-marketing-page/plannedparenthood_22_PA.png'
import grid_notco from './img/mobile-marketing-page/notco_los_angeles_22.png'
import grid_seinfeld_squared from './img/mobile-marketing-page/seinfeld_squared.png'
import grid_wesbrands from './img/mobile-marketing-page/wes_brands_x_miami_22.png'
import grid_publix from './img/mobile-marketing-page/publix2_square.png'

import benefits_slideshow_1 from './img/mobile-marketing-page/gearbox_boderlands_seattle_22.png'
import benefits_slideshow_2 from './img/mobile-marketing-page/tums_smorgasberg_jersey_city_22.png'
import benefits_slideshow_3 from './img/mobile-marketing-page/set_active_NYC_22.png'
import benefits_slideshow_4 from './img/mobile-marketing-page/batiste_denver_22.png'

import benefits_grid_1 from './img/mobile-marketing-page/culvers_chicago_22_2.png'
import benefits_grid_2 from './img/mobile-marketing-page/culvers_chicago_22_1.png'
import benefits_grid_3 from './img/mobile-marketing-page/culvers_chicago_22_3.png'

import testimonials_grid_1 from './img/mobile-marketing-page/daringfood_expowest_3.png'
import testimonials_grid_2 from './img/mobile-marketing-page/daringfood_expowest_1.png'
import testimonials_grid_3 from './img/mobile-marketing-page/daringfood_expowest_2.png'

import balloonsten from 'assets/svg/balloons-ten.svg'
import sausagetruck from 'assets/svg/sausage-truck.svg'
import pencil from 'assets/svg/pencil.svg'
import mapicon from 'assets/svg/map-icon.svg'
import calculator from 'assets/svg/calculator.svg'
import moneycake from 'assets/svg/money-cake.svg'
import burgercheckmark from 'assets/svg/burger-checkmark.svg'
import guarantee from 'assets/svg/guarantee.svg'
import redheart from 'assets/svg/red-heart.svg'
import truckillustration2 from 'assets/svg/truck-illustration-2.svg'
import leftquote from 'assets/svg/left-quote.svg'

import clutchAward from 'assets/img/clutch-award.png'
import exAward from 'assets/img/ex-award.png'
import aaaAward from 'assets/img/aaa-award.png'
import scaAward from 'assets/img/sca-award.png'
import eeaAward from 'assets/img/eea-award.png'

import budweiser from './img/logos/budweiser.png'
import pepsi from './img/logos/pepsi.png'
import notco from './img/logos/notco.png'
import impossible from './img/logos/impossible.png'
import sony from './img/logos/sony.png'
import bumble from './img/logos/bumble.png'
import helloKitty from './img/logos/hello-kitty.png'
import vote from './img/logos/vote.png'
import barbie from './img/logos/barbie.png'
import ciroc from './img/logos/ciroc.png'
import shakeshack from './img/logos/shakeshack.png'
import walmart from './img/logos/walmart.png'

const menuItems = [
  {
    title: 'Benefits',
    url: `#benefits`,
  },
  {
    title: 'Why Us?',
    url: `#why-us`,
  },
  {
    title: 'Testimonials',
    url: `#testimonials`,
  },
  {
    title: 'Case Studies',
    url: `#case-studies`,
  },
  {
    title: 'FAQ',
    url: `#faq`,
  },
]

const googleMetaTags = JSON.stringify(
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is an experiential mobile marketing tour?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>An experiential mobile marketing tour is a type of marketing campaign that involves taking a branded experience on the road to different locations. This can involve setting up a mobile showroom, food truck promotion, or pop-up shop in various public spaces or at specific events to engage with potential customers and create memorable brand experiences. Locations can include different cities or can be limited to a specific market.\n\n<p>The goal is to create a more immersive and impactful way for customers to interact with a business or product, while also generating buzz and awareness through social media and word-of-mouth.</p>
          `
        }
      },{
        "@type": "Question",
        "name": "How can an experiential mobile marketing tour benefit my business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>The magic is in the live experience. Here are a few reasons why an experiential mobile marketing tour works:</p>\n<ul>\n    <li>\n        It allows you to directly engage with potential customers in a more personal and memorable way, creating a deeper connection between your brand and audience.\n    </li>\n    <li>\n        By bringing your brand experience to different locations, you can reach a wider audience and generate more buzz and excitement around your product or service.\n    </li>\n    <li>\n        Experiential mobile marketing tours also provide opportunities for social media sharing and user-generated content, which can help increase brand awareness, drive traffic to your website or increase sales and revenue.\n    </li>\n    <li>\n        Additionally, by creating unique experiences for customers, you can differentiate yourself from competitors and build stronger relationships with existing customers.\n    </li>\n</ul>`
        }
      },{
        "@type": "Question",
        "name": "How do I plan and execute an experiential mobile marketing tour for my business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>Planning and executing an experiential mobile marketing tour for your business is a complex process and takes a lot of resources.</p>\n<p>Here is our process when we work with a client brand:</p>\n<ol>\n    <li>\n        Define and understand your goals: Start by defining the goals of your tour. What do you want to achieve? Is it increasing brand awareness, generating leads or sales, or something else?\n    </li>\n    <li>\n        Who is your target audience: What are their interests and behaviors? This will help you determine the best locations and events to attend.\n    </li>\n    <li>\n        Develop creative concepts: Based on your goals and target audience, develop a unique concept for your tour that will resonate with customers. Consider interactive experiences such as product demos, giveaways, photo booths or virtual reality experiences.\n    </li>\n    <li>\n        Determine logistics and staffing: What is the most effective way to go on the road? Consider transportation options like renting vehicles or sourcing equipment at the local level.  You may need to hire staff to manage the experience and logistics such as equipment needs.\n    </li>\n    <li>\n        Build the experience: Once you have identified the events and locations that make sense for your brand, you'll need to fabricate and source all the assets you need to make the brand experience come to life.\n    </li>\n    <li>\n        Hit the road: As the tour begins and progresses, adjustments will always need to be made on the ground. Have a trusted team that can independently problem-solve so that your audience has a great experience in every location.\n    </li>\n    <li>\n        Measure Success: Use the metrics that make sense for you, whether it's impressions, social media engagement, customer feedback, or revenue.\n    </li>\n</ol>\n<p>We lead our brand clients through these steps from the very beginning and provide guidance along the way. By following these steps carefully, you can plan and execute an effective experiential mobile marketing tour that will help grow your business by engaging with customers in a unique way while creating memorable brand experiences.</p>`
        }
      },{
        "@type": "Question",
        "name": "Can any type of business benefit from an experiential mobile marketing tour, or is it best suited for certain industries?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>A mobile marketing tour can work for any business where event-based marketing makes sense. This means having a target audience, a brand identity, a good budget, and a product or service that can draw the audience in.</p>\n<p>We've worked with companies from many industries, including the following:</p>\n<ol>\n    <li>\n        Food and Beverage\n    </li>\n    <li>\n        Software\n    </li>\n    <li>\n        Travel and Hospitality\n    </li>\n    <li>\n        Sports and Entertainment\n    </li>\n    <li>\n        Nonprofit and Government\n    </li>\n</ol>\n<p>A simple way to think about it is if you have a reason to put on an event such as a pop-up or food truck promotion, then it might make sense to repeat that event and turn it into a tour.</p>\n<p>However, if your target audience is very specific, such as a tradeshow, then a tour will probably not be the best option.</p>`
        }
      },{
        "@type": "Question",
        "name": "What's the difference between a traditional marketing campaign and an experiential mobile marketing tour?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>The main difference between a traditional marketing campaign and an experiential mobile marketing tour is the level of engagement and interaction with customers.</p>\n<p>Traditional marketing campaigns typically involve one-way communication, such as television ads, billboards or print ads, where the brand communicates its message to the target audience without much opportunity for feedback or interaction.</p>\n<p>On the other hand, experiential mobile marketing tours are designed to create memorable experiences that actively engage customers through interactive demonstrations, product samples or other hands-on activities.</p>\n<p>The result is a more personal connection with customers by providing them with unique experiences that they can't get elsewhere.</p>\n<p>Another key difference is that traditional marketing campaigns often focus on reaching a large audience at once, while experiential mobile marketing tours tend to be more targeted and localized. By setting up at specific events or locations where your target audience is likely to be present, you can create a more intimate experience that resonates with potential customers.</p>\n<p>Overall, while both traditional and experiential mobile marketing campaigns have their place in a comprehensive marketing strategy, experiential tours offer a unique opportunity for brands to connect with customers in a more authentic and engaging way.</p>`
        }
      },{
        "@type": "Question",
        "name": "How long should an experiential mobile marketing tour last, and how many locations should we go to?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>The length and number of stops for an experiential mobile marketing tour will depend on a number of factors, such as the goals of the tour, the budget, and the target audience.</p>\n<p>Generally speaking, there will be upfront costs to set up a tour, and a cost to activate at each location. Understanding these costs before committing an entire budget will minimize the risk of overspending. In some cases, you may want to start with one event at one location before taking the show on the road.</p>\n<p>As for the number of stops, this will depend on how many locations you can realistically visit within your timeframe and budget. It's important to carefully select each stop based on factors such as foot traffic, accessibility, and relevance to your target audience.</p>\n<p>When planning your tour, it's also important to consider logistics such as transportation, staffing needs, and equipment requirements.</p>`
        }
      },{
        "@type": "Question",
        "name": "How do I measure the success of my experiential mobile marketing tour?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>Measuring the success of an experiential mobile marketing tour depends on the reasons why you want to market through live events. The first thing to remember is that it will be difficult to measure it the same as a digital marketing campaign.</p>\n<p>With this in mind, there are several key metrics that you can use to evaluate its impact:</p>\n<ol>\n    <li>\n        <p><strong>Foot traffic:</strong> One way to measure the success of your tour is by tracking the number of people who visit your activation. This will give you a sense of how many people were exposed to your brand and had the opportunity to engage with your experiential marketing campaign.</p>\n    </li>\n    <li>\n        <p><strong>Social media engagement (and PR):</strong> Another way to measure the success of your tour is by tracking social media engagement, such as likes, comments, shares, and mentions. Encouraging visitors to share their experiences on social media can help amplify your message and reach a wider audience.</p>\n    </li>\n    <li>\n        <p><strong>Sales:</strong> Ultimately, the success of any marketing campaign is measured by its impact on sales. Tracking sales during and after your tour can help you determine whether it was worth the investment in terms of generating revenue for your business.</p>\n    </li>\n    <li>\n        <p><strong>Surveys and feedback:</strong> Collecting feedback from visitors via surveys or other means can provide valuable insights into how well your experiential marketing campaign resonated with your target audience.</p>\n    </li>\n</ol>\n<p>By tracking these metrics (and others that may be relevant to your specific campaign), you can gain a better understanding of what worked well and what could be improved in future tours.</p>`
        }
      },{
        "@type": "Question",
        "name": "What types of experiences or activities can be included in an experiential mobile marketing tour?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>Designing experiences for your marketing tour requires a deep understanding of your audience or customers. Assuming that you have this first step down, there are many different types of experiences and activities that can be included in an experiential mobile marketing tour.</p>\n<p>When we work with clients, we provide creative design and services that take into account the goals of the campaign and the restrictions (budget, footprint, time, etc.). Understanding exactly what the brand wants and needs helps us shape the elements of the experience together with the client.</p>\n<p>Here are a few examples:</p>\n<ol>\n    <li><strong>Interactive exhibits:</strong> These can include hands-on displays or simulations that allow visitors to learn more about your brand or products.</li>\n    <li><strong>Product demos:</strong> Giving visitors the opportunity to try out your products first-hand can be a powerful way to build brand awareness and generate interest.</li>\n    <li><strong>Sampling events:</strong> Free samples of your products can be an effective way to introduce potential customers to your brand and generate interest in what you have to offer.</li>\n    <li><strong>Games and contests:</strong> Hosting games or contests that tie into your brand messaging can be a great way to create excitement and encourage participation.</li>\n    <li><strong>Photo opportunities:</strong> Creating Instagram-worthy photo opportunities with branded backdrops, props, or costumes can help generate buzz on social media and increase the reach of your campaign.</li>\n    <li><strong>Celebrity appearances:</strong> Partnering with influencers or celebrities who align with your brand values can help attract attention and create memorable experiences for visitors.</li>\n</ol>\n<p>The key to any of the above methods is to thoughtfully insert your brand identity so that the attendee can emotionally connect their positive experience with you. In our experience, we've learned that engaging multiple senses (touch, smell, sound, taste) can produce this effect.</p>`
        }
      },{
        "@type": "Question",
        "name": "Are there any legal or permit requirements I need to consider when planning an experiential mobile marketing tour?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `<p>Yes. Permitting is one of the biggest hurdles to setting up a successful marketing tour. There are several legal and permit requirements that you should consider when planning an experiential mobile marketing tour.</p>\n<p>Here are a few key considerations:</p>\n<ol>\n    <li><strong>Permits:</strong> Depending on the location of your tour stops, you may need to obtain permits from local authorities or venue owners in order to set up booths or exhibits. Be sure to research the specific requirements for each location well in advance of your tour dates. Some permits may take weeks or months to obtain from a local government.</li>\n    <li><strong>Insurance:</strong> It's important to have liability insurance in case of any accidents or injuries that occur during your tour. Make sure you have adequate coverage before hitting the road.</li>\n    <li><strong>Branding and trademark issues:</strong> If you plan to use logos, slogans, or other branded materials during your tour, be sure that you have the necessary rights and permissions to do so.</li>\n    <li><strong>Privacy concerns:</strong> If you plan to collect personal information from visitors (such as email addresses or phone numbers) or take photos, make sure that you are following all relevant privacy laws and regulations, and have proper releases in place.</li>\n    <li><strong>Health and safety regulations:</strong> Depending on the nature of your experience, there may be health and safety regulations that you need to comply with in order to ensure the well-being of both visitors and staff.</li>\n</ol>\n<p>By taking these considerations into account when planning your experiential mobile marketing tour, you can help ensure that it runs smoothly and avoid any legal or regulatory issues along the way.</p>`
        }
      }
    ]}
)

export default function MobileMarketingToursPage(props) {

  const { Modal, openModal } = useLeadModal()

  return (
    <Layout>
      <Helmet>
        <title>Mobile Marketing Tours - Roaming Hunger</title>
        <meta name="description" content="Take your brand on tour and connect with your audience wherever they are. Since 2009 we’ve helped brands grow through experiential marketing tours."></meta>
        <meta name="og:title" content={`Mobile Marketing Tours`}></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <BackgroundCover imageUrl={bannerImg}>
        <div className={styles.gradient}>
          <div className="container text-white py-20">
            <div className="xl:w-1/2 m-auto">
              <h1 className="font-platform leading-none text-5xl text-center leading-tight mb-6">
                Mobile Marketing Tours
              </h1>
              <p className="text-lg text-center font-light leading-tight mb-5 leading-relaxed">
                Take your brand on tour and connect with your audience wherever they are.
              </p>
              <button
                className="btn btn-green font-platform text-2xl px-5 py-2 m-auto block"
                children="Get Started"
                onClick={openModal}
              />
            </div>
          </div>
        </div>
      </BackgroundCover>
      <NavbarFixed
        bgColor="bg-blue"
        className="text-white font-normal text-md"
        buttonStyle="text-white border-white border-2"
        onButtonClick={openModal}
        menuItems={menuItems}
      />
      <div id="clients" className="bg-white py-12">
        <div className="container text-center">
          <h2 className="font-platform text-3xl text-center text-navy w-full mb-6">A Few of the Brands We've Taken On Tour</h2>
          <Slider
            arrows={false}
            dots={true}
            slidesToShow={4}
            slidesToScroll={4}
            responsive={[{
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            }]}
          >
            <div className="flex justify-center items-center">
              <img src={budweiser} alt="budweiser-logo" className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={pepsi} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={notco} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={impossible} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={sony} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={bumble} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={helloKitty} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={vote} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={barbie} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={ciroc} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={shakeshack} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={walmart} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
          </Slider>
        </div>
      </div>

      <div className="bg-white">
        <div className="container max-w-4xl pt-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">
            What Are Experiential Mobile Marketing Tours?
          </h2>
          <p className="mt-6">
            Mobile marketing tours are a series of experiential marketing events designed to showcase your brand or product to a specific audience. The tour takes your brand on the road to strategic locations, whether that's inside of a market or in different markets around the country or the world.
          </p>
        </div>
        <div className="container max-w-4xl py-12">
          <div className="grid grid-cols-3 gap-1 md:gap-3 lg:gap-6 text-white">
            <img src={grid_select_la} name="Select LA" />
            <img src={grid_plannedparenthood} name="Planned Parenthood" />
            <img src={grid_notco} name="NotCo" />
            <img src={grid_seinfeld_squared} name="Seinfeld Squared" />
            <img src={grid_wesbrands} name="Wes Brands X Miami" />
            <img src={grid_publix} name="Publix" />
          </div>
        </div>
      </div>
      <div id="benefits" className="container max-w-4xl py-20">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">
          Benefits of Experiential Mobile Marketing Tours
        </h2>
        <p className="pb-6 text-center">
          Live experiences create micro-moments that leave a lasting impression. Your audience is waiting.
        </p>
      </div>

      <div className="container max-w-4xl">
        <Slider
          arrows={true}
          dots={false}
          slidesToShow={1}
          slidesToScroll={1}
          className={styles.slider_wrapper}
          responsive={[{
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]}
        >
          {[
            {
              image: benefits_slideshow_1,
              title: "Engage Your Audience Where They Are - ",
              description: "The power of a mobile marketing tour comes from meeting your customers where they live, work, or play."
            },
            {
              image: benefits_slideshow_2,
              title: "Showcase Your Brand Through Interactive Experiences - ",
              description: "The best mobile marketing campaigns are inviting and interactive, and make a lasting positive impression."
            },
            {
              image: benefits_slideshow_3,
              title: "Get Insights Into Your Brand - ",
              description: "Collect data to understand how the public sees your brand, measure brand affinity, and gain insights into your customers."
            },
            {
              image: benefits_slideshow_4,
              title: "Access New Markets - ",
              description: "Take your products on the road and reach out to target audiences beyond your current customer base and geographic boundaries."
            },
          ].map(advantage => (
            <div key={advantage.title}>
              <img src={advantage.image} className={["m-auto"]}/>
              <p className="bg-white text-navy text-sm font-light px-5 lg:px-10 py-5">
                <span className="font-bold text-blue">{advantage.title} </span>{advantage.description}
              </p>
            </div>
          ))}
        </Slider>
      </div>

      <div className="container max-w-4xl my-6 bg-navy p-12">
        <p className="text-center text-white italic pb-6">
          In our over 10 years of experience, we've taken brands to meet customers where they live and play, all over the world. Our mobile tour takes your product or service to neighborhoods, festivals, and more to reach new audiences and increase your brand’s visibility.
        </p>
        <button
          className="btn btn-green font-platform text-xl px-5 py-2 m-auto block"
          children="Get Started"
          onClick={openModal}
        />
      </div>

      <div className="px-0 container max-w-4xl my-6">
        <div className="grid grid-cols-3 gap-0 text-white">
          <img src={benefits_grid_1} name="Culvers Chicago" />
          <img src={benefits_grid_2} name="Culvers Chicago" />
          <img src={benefits_grid_3} name="Culvers Chicago" />
        </div>
      </div>

      <div id="why-us" className="bg-blue">
        <div className="container max-w-4xl py-20">
          <h2 className="text-3xl text-white text-center font-platform mb-6">
            Why Choose Our Experiential Marketing Company?
          </h2>
          <p className="text-white text-center">
            Our team is your team. Tap into unlimited opportunities to engage with customers in meaningful ways, such as interactive displays, virtual reality experiences, product demos, pop-up stores, and more.
          </p>
          <div className="grid grid-cols-3 gap-1 md:gap-3 lg:gap-10 text-white">
            <div className="text-center">
              <img className="m-auto mt-10" src={balloonsten} style={{maxWidth: "60px", height: "100px"}}/>
              <p>Over Ten Years of Creating Memorable Mobile Marketing Tours</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={sausagetruck} style={{maxWidth: "60px", height: "100px"}}/>
              <p>Customized Solutions to Meet Your Brand Objectives</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={pencil} style={{maxWidth: "60px", height: "100px"}}/>
              <p>End-to-End Support from Planning to Execution</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={mapicon} style={{maxWidth: "60px", height: "100px"}}/>
              <p>Location Intelligence</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={calculator} style={{maxWidth: "60px", height: "100px"}}/>
              <p>Logistical Expertise & Support</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={moneycake} style={{maxWidth: "60px", height: "100px"}}/>
              <p>Creative, Digital, & Fabrication Services</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={burgercheckmark} style={{maxWidth: "60px", height: "100px"}}/>
              <p>A Network of Over 20,000 Vendors</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={guarantee} style={{maxWidth: "60px", height: "100px"}}/>
              <p>Safety, Legal, and Permitting</p>
            </div>
            <div className="text-center">
              <img className="m-auto mt-10" src={redheart} style={{maxWidth: "60px", height: "100px"}}/>
              <p>We're Nice People</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-4xl my-6">
        <div className="grid grid-cols-3 gap-0 text-white">
          <img src={testimonials_grid_1} name="Daring Foods Expo West" />
          <img src={testimonials_grid_2} name="Daring Foods Expo West" />
          <img src={testimonials_grid_3} name="Daring Foods Expo West" />
        </div>
      </div>
      <div id="testimonials" className="container max-w-4xl pt-20 px-0">
        <h2 className="font-platform text-3xl text-center text-navy w-full mb-6">
          Why Our Clients Love Us
        </h2>
        <img src={truckillustration2} className="m-auto" style={{maxWidth: "400px"}} />
        <div className="flex max-w-2xl mx-auto my-5 px-8 py-10 bg-gray-200 shadow">
          <div>
            <img src={leftquote} className="pr-5 pt-2" style={{width: "75px"}} />
          </div>
          <div className="text-navy flex-1">
            <p className="font-normal italic">
              The RMNG team has been a consistent pleasure to work with across various sampling and food truck campaigns! The team is great at communicating and provides a very organized way to work together and keep the many moving pieces of an activation in one clear place to follow. We look forward to more activations together!
            </p>
            <p className="text-right font-black mt-2">
              &mdash; Jaclyn, Rapport
            </p>
          </div>
        </div>
        <div className="flex max-w-2xl mx-auto my-5 px-8 py-10 bg-gray-200 shadow">
          <div>
            <img src={leftquote} className="pr-5 pt-2" style={{width: "75px"}} />
          </div>
          <div className="text-navy flex-1">
            <p className="font-normal italic">
              RMNG was very thorough and detailed with any requests or needs. They exceeded my expectations with the truck wrap and overall event execution.
            </p>
            <p className="text-right font-black mt-2">
              &mdash; Kim, Select
            </p>
          </div>
        </div>
        <div className="flex max-w-2xl mx-auto my-5 px-8 py-10 bg-gray-200 shadow">
          <div>
            <img src={leftquote} className="pr-5 pt-2" style={{width: "75px"}} />
          </div>
          <div className="text-navy flex-1">
            <p className="font-normal italic">
              The event was really set up as a thank you event for John Deere customers - however, with the networking aspect as a value add - we were actually able to secure multiple orders and start new conversations for future orders.
            </p>
            <p className="text-right font-black mt-2">
              &mdash; Jenny, John Deere
            </p>
          </div>
        </div>
      </div>
      <div id="awards" className="bg-white">
        <div className="container text-center py-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">Recent Awards</h2>
          <div className="grid gap-10 md:gap-20 grid-cols-2 md:grid-cols-5">
            <div className="flex justify-center">
              <img src={eeaAward} className="block" style={{height: '100px'}} />
            </div>
            <div className="flex justify-center">
              <img src={scaAward} className="block" style={{height: '100px'}} />
            </div>
            <div className="flex justify-center">
              <img src={exAward} className="block" style={{height: '100px'}} />
            </div>
            <div className="flex justify-center">
              <img src={clutchAward} className="block" style={{height: '100px'}} />
            </div>
            <div className="flex justify-center">
              <img src={aaaAward} className="block" style={{height: '100px'}} />
            </div>
          </div>
        </div>
      </div>

      <div id="case-studies" className="container max-w-4xl py-8">
        <RecentActivations
          case_study_tags={['mobile_marketing_tour']}
        />
      </div>

      <div className="bg-blue text-white text-center py-12 px-6">
        <h2 className="text-3xl font-platform mb-4">Ready to Launch an Experiential Mobile Marketing Tour?</h2>
        <p className="text-md pb-5"><Phone className="inline" size={16} /> (424) 777-2550</p>
        <p className="text-md pb-5"><Mail className="inline" size={16} /> rmng@roaminghunger.com</p>
        <button
          className="btn btn-navy font-platform text-md mt-2 px-5 py-2"
          children="Contact Us"
          onClick={openModal}
        />
      </div>

      <div id="faq" className="bg-navy py-20 text-white">
        <div className="container max-w-4xl m-auto">
          <h2 className="text-3xl text-white text-center font-platform mb-6">Frequently Asked Questions</h2>

          <h3 className="text-xl font-platform mb-4 mt-8">
            What is an experiential mobile marketing tour?
          </h3>
          <p className="font-light mb-4">
            An experiential mobile marketing tour is a type of marketing campaign that involves taking a branded experience on the road to different locations. This can involve setting up a mobile showroom, food truck promotion, or pop-up shop in various public spaces or at specific events to engage with potential customers and create memorable brand experiences. Locations can include different cities or can be limited to a specific market.
          </p>
          <p className="font-light mb-4">
            The goal is to create a more immersive and impactful way for customers to interact with a business or product, while also generating buzz and awareness through social media and word-of-mouth.
          </p>

          <h3 className="text-xl font-platform mb-4 mt-8">
            How can an experiential mobile marketing tour benefit my business?
          </h3>
          <p className="font-light mb-4">
            The magic is in the live experience. Here are a few reasons why an experiential mobile marketing tour works:
          </p>
          <p className="font-light mb-4">
            It allows you to directly engage with potential customers in a more personal and memorable way, creating a deeper connection between your brand and audience.
          </p>
          <ol className="list-disc pl-4 font-light mb-4">
            <li>By bringing your brand experience to different locations, you can reach a wider audience and generate more buzz and excitement around your product or service.</li>
            <li>Experiential mobile marketing tours also provide opportunities for social media sharing and user-generated content, which can help increase brand awareness, drive traffic to your website or increase sales and revenue.</li>
            <li>Additionally, by creating unique experiences for customers, you can differentiate yourself from competitors and build stronger relationships with existing customers.</li>
          </ol>

          <h3 className="text-xl font-platform mb-4 mt-8">
            How do I plan and execute an experiential mobile marketing tour for my business?
          </h3>
          <p className="font-light mb-4">
            Planning and executing an experiential mobile marketing tour for your business is a complex process and takes a lot of resources.
          </p>
          <p className="font-light mb-4">
            Here is our process when we work with a client brand:
          </p>
          <ol className="list-decimal pl-4 mb-4 font-light">
            <li>Define and understand your goals: Start by defining the goals of your tour. What do you want to achieve? Is it increasing brand awareness, generating leads or sales, or something else?</li>
            <li>Who is your target audience: What are their interests and behaviors? This will help you determine the best locations and events to attend.</li>
            <li>Develop creative concepts: Based on your goals and target audience, develop a unique concept for your tour that will resonate with customers. Consider interactive experiences such as product demos, giveaways, photo booths or virtual reality experiences.</li>
            <li>Determine logistics and staffing: What is the most effective way to go on the road? Consider transportation options like renting vehicles or sourcing equipment at the local level.  You may need to hire staff to manage the experience and logistics such as equipment needs.</li>
            <li>Build the experience: Once you have identified the events and locations that make sense for your brand, you'll need to fabricate and source all the assets you need to make the brand experience come to life.</li>
            <li>Hit the road: As the tour begins and progresses, adjustments will always need to be made on the ground. Have a trusted team that can independently problem-solve so that your audience has a great experience in every location.</li>
            <li>Measure Success: Use the metrics that make sense for you, whether it's impressions, social media engagement, customer feedback, or revenue.</li>
          </ol>
          <p className="font-light mb-4">
            We lead our brand clients through these steps from the very beginning and provide guidance along the way. By following these steps carefully, you can plan and execute an effective experiential mobile marketing tour that will help grow your business by engaging with customers in a unique way while creating memorable brand experiences.
          </p>

          <h3 className="text-xl font-platform mb-4 mt-8">
            Can any type of business benefit from an experiential mobile marketing tour, or is it best suited for certain industries?
          </h3>
          <p className="font-light mb-4">
            A mobile marketing tour can work for any business where event-based marketing makes sense. This means having a target audience, a brand identity, a good budget, and a product or service that can draw the audience in.
          </p>
          <p className="font-light mb-4">
            We've worked with companies from many industries, including the following:
          </p>
          <ol className="list-decimal pl-4 mb-4 font-light">
            <li>Food and Beverage</li>
            <li>Software</li>
            <li>Travel and Hospitality</li>
            <li>Sports and Entertainment</li>
            <li>Nonprofit and Government</li>
          </ol>
          <p className="font-light mb-4">
            A simple way to think about it is if you have a reason to put on an event such as a pop-up or food truck promotion, then it might make sense to repeat that event and turn it into a tour.
          </p>
          <p className="font-light mb-4">
            However, if your target audience is very specific, such as a tradeshow, then a tour will probably not be the best option.
          </p>

          <h3 className="text-xl font-platform mb-4 mt-8">
            What's the difference between a traditional marketing campaign and an experiential mobile marketing tour?
          </h3>
          <p className="font-light mb-4">
            The main difference between a traditional marketing campaign and an experiential mobile marketing tour is the level of engagement and interaction with customers.
          </p>
          <p className="font-light mb-4">
            Traditional marketing campaigns typically involve one-way communication, such as television ads, billboards or print ads, where the brand communicates its message to the target audience without much opportunity for feedback or interaction.
          </p>
          <p className="font-light mb-4">
            On the other hand, experiential mobile marketing tours are designed to create memorable experiences that actively engage customers through interactive demonstrations, product samples or other hands-on activities.
          </p>
          <p className="font-light mb-4">
            The result is a more personal connection with customers by providing them with unique experiences that they can't get elsewhere.
          </p>
          <p className="font-light mb-4">
            Another key difference is that traditional marketing campaigns often focus on reaching a large audience at once, while experiential mobile marketing tours tend to be more targeted and localized. By setting up at specific events or locations where your target audience is likely to be present, you can create a more intimate experience that resonates with potential customers.
          </p>
          <p className="font-light mb-4">
            Overall, while both traditional and experiential mobile marketing campaigns have their place in a comprehensive marketing strategy, experiential tours offer a unique opportunity for brands to connect with customers in a more authentic and engaging way.
          </p>
          
          <h3 className="text-xl font-platform mb-4 mt-8">
            How long should an experiential mobile marketing tour last, and how many stops should it make?
          </h3>
          <p className="font-light mb-4">
            The length and number of stops for an experiential mobile marketing tour will depend on a number of factors, such as the goals of the tour, the budget, and the target audience.
          </p>
          <p className="font-light mb-4">
            Generally speaking, there will be upfront costs to set up a tour, and a cost to activate at each location. Understanding these costs before committing an entire budget will minimize the risk of overspending. In some cases, you may want to start with one event at one location before taking the show on the road.
          </p>
          <p className="font-light mb-4">
            As for the number of stops, this will depend on how many locations you can realistically visit within your timeframe and budget. It's important to carefully select each stop based on factors such as foot traffic, accessibility, and relevance to your target audience.
          </p>
          <p className="font-light mb-4">
            When planning your tour, it's also important to consider logistics such as transportation, staffing needs, and equipment requirements.
          </p>

          <h3 className="text-xl font-platform mb-4 mt-8">
            How do I measure the success of my experiential mobile marketing tour?
          </h3>
          <p className="font-light mb-4">
            Measuring the success of an experiential mobile marketing tour depends on the reasons why you want to market through live events. The first thing to remember is that it will be difficult to measure it the same as a digital marketing campaign.
          </p>
          <p className="font-light mb-4">
            With this in mind, there are several key metrics that you can use to evaluate its impact:
          </p>
          <ol className="list-decimal pl-4 mb-4 font-light">
            <li>Foot traffic: One way to measure the success of your tour is by tracking the number of people who visit your activation. This will give you a sense of how many people were exposed to your brand and had the opportunity to engage with your experiential marketing campaign.</li>
            <li>Social media engagement (and PR): Another way to measure the success of your tour is by tracking social media engagement, such as likes, comments, shares, and mentions. Encouraging visitors to share their experiences on social media can help amplify your message and reach a wider audience.</li>
            <li>Sales: Ultimately, the success of any marketing campaign is measured by its impact on sales. Tracking sales during and after your tour can help you determine whether it was worth the investment in terms of generating revenue for your business.</li>
            <li>Surveys and feedback: Collecting feedback from visitors via surveys or other means can provide valuable insights into how well your experiential marketing campaign resonated with your target audience.</li>
          </ol>
          <p className="font-light mb-4">
            By tracking these metrics (and others that may be relevant to your specific campaign), you can gain a better understanding of what worked well and what could be improved in future tours.
          </p>

          <h3 className="text-xl font-platform mb-4 mt-8">
            What types of experiences or activities can be included in an experiential mobile marketing tour?
          </h3>
          <p className="font-light mb-4">
            Designing experiences for your marketing tour requires a deep understanding of your audience or customers. Assuming that you have this first step down, there are many different types of experiences and activities that can be included in an experiential mobile marketing tour.
          </p> 
          <p className="font-light mb-4">
            When we work with clients, we provide creative design and services that take into account the goals of the campaign and the restrictions (budget, footprint, time, etc.). Understanding exactly what the brand wants and needs helps us shape the elements of the experience together with the client.
          </p>
          <p className="font-light mb-4">
            Here are a few examples:
          </p>
          <ol className="list-decimal pl-4 mb-4 font-light">
            <li>Interactive exhibits: These can include hands-on displays or simulations that allow visitors to learn more about your brand or products.</li>
            <li>Product demos: Giving visitors the opportunity to try out your products first-hand can be a powerful way to build brand awareness and generate interest.</li>
            <li>Sampling events: Free samples of your products can be an effective way to introduce potential customers to your brand and generate interest in what you have to offer.</li>
            <li>Games and contests: Hosting games or contests that tie into your brand messaging can be a great way to create excitement and encourage participation.</li>
            <li>Photo opportunities: Creating Instagram-worthy photo opportunities with branded backdrops, props, or costumes can help generate buzz on social media and increase the reach of your campaign.</li>
            <li>Celebrity appearances: Partnering with influencers or celebrities who align with your brand values can help attract attention and create memorable experiences for visitors.</li>
          </ol>
          <p className="font-light mb-4">
            The key to any of the above methods is to thoughtfully insert your brand identity so that the attendee can emotionally connect their positive experience with you. In our experience, we've learned that engaging multiple senses (touch, smell, sound, taste) can produce this effect.
          </p>

          <h3 className="text-xl font-platform mb-4 mt-8">
            Are there any legal or permit requirements I need to consider when planning an experiential mobile marketing tour?
          </h3>
          <p className="font-light mb-4">
            Yes. Permitting is one of the biggest hurdles to setting up a successful marketing tour. There are several legal and permit requirements that you should consider when planning an experiential mobile marketing tour.
          </p>
          <p className="font-light mb-4">
            Here are a few key considerations:
          </p>
          <ol className="list-decimal pl-4 mb-4 font-light">
            <li>Permits: Depending on the location of your tour stops, you may need to obtain permits from local authorities or venue owners in order to set up booths or exhibits. Be sure to research the specific requirements for each location well in advance of your tour dates. Some permits may take weeks or months to obtain from a local government.</li>
            <li>Insurance: It's important to have liability insurance in case of any accidents or injuries that occur during your tour. Make sure you have adequate coverage before hitting the road.</li>
            <li>Branding and trademark issues: If you plan to use logos, slogans, or other branded materials during your tour, be sure that you have the necessary rights and permissions to do so.</li>
            <li>Privacy concerns: If you plan to collect personal information from visitors (such as email addresses or phone numbers) or take photos, make sure that you are following all relevant privacy laws and regulations, and have proper releases in place.</li>
            <li>Health and safety regulations: Depending on the nature of your experience, there may be health and safety regulations that you need to comply with in order to ensure the well-being of both visitors and staff.</li>
          </ol>
          <p className="font-light mb-4">
            By taking these considerations into account when planning your experiential mobile marketing tour, you can help ensure that it runs smoothly and avoid any legal or regulatory issues along the way.
          </p>
        </div>
      </div>
      <Modal />
    </Layout>
  )
}